<template>
  <div class="company-details">
    <div class="company-top-bar " ref="optionsTopBar" >
      <!-- <h6 class="pull-left">{{$t('catalogProd.single')}} {{$t('catalogProdOpt.plural')}}</h6> -->
      <div class="text-right">
        <p class="">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-success btn">{{$t('general.update')}}</button>
        </p>
      </div>
    </div>
    <div ref="compDetailsContainer" class="company-wrap" :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - 1 + 'px'}">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <form class="clearfix pad-bt-15 row">
            <div class="col-md-12">
              <h5 class="">
                {{$t('settingCompany.title')}}
                <button class="btn btn-info pull-right"
                          @click.prevent="addLocation"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('settingCompany.location')}}</button>
              </h5>
              <hr/>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('settingCompany.name')}}</label>
                <input type="text" name="name" :placeholder="$t('settingCompany.name')" v-model="model.name" v-validate="modelValidate.name" class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('settingCompany.lang')}}</label>
                  <select class="form-control" placeholder=" - Select Language - " v-model="model.language" v-validate="modelValidate.language">
                    <option v-for="(label, key) in languages"
                                :value="key"
                                :label="label"
                                :key="key">{{label}}</option>
                  </select>
                  <small class="text-danger" v-if="errors.has('language')">
                    {{ getError('language') }}
                  </small>
              </div>
            </div>
            <div class="col-lg-1 col-md-2 ">
              <div class="form-group">
                <label>{{$t('settingsTips.state')}}</label>
                <br/>
                <p-switch v-model="model.tips_in_use" type="success"></p-switch>
              </div>
            </div>
            <div class="col-lg-5 col-md-4 ">
              <div >
                <div class="form-group">
                  <label>{{$t('settingsTips.tipsTaxes')}}</label>
                  <v-select v-model="model.tips_taxes"
                            multiple
                            :options="taxes"
                            value="id"
                            label="name"
                            :disabled="!model.tips_in_use">
                  </v-select>
                  <small class="text-danger" v-if="errors.has(model.tips_taxes)">
                  {{ getError(model.tips_taxes) }}
                </small>
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
      <template v-for="location in model.locations_details">
      <div class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
              <div class="col-md-12">
                <h5 class="company-location">
                  <i class="ti-home"></i> {{$t('settingCompany.bussLoc')}}: {{location.name}}
                  <button class="btn btn-danger pull-right btn-fill mar-to--5"
                          v-if="showDelete || model.isNew"
                          @click.prevent="deleteLocation(location.id)">{{$t('general.delete')}}</button>
                </h5>
                <hr/>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingCompany.name')}}</label>
                  <input type="text" name="phome" :placeholder="$t('settingCompany.name')" v-model="location.name" v-validate="modelValidate.name" class="form-control">
                </div>
              </div>
              <br style="clear:both;" />
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingCompany.phone')}}</label>
                  <input type="text" name="phome" placeholder="$t('settingCompany.phone')" v-model="location.phone" v-validate="modelValidate.phone" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingCompany.email')}}</label>
                  <input type="text" name="email" :placeholder="$t('settingCompany.email')" v-model="location.email" v-validate="modelValidate.email" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.street')}}</label>
                  <input type="text" v-model="location.street" name="street" :placeholder="$t('settingCompany.street')" class="form-control" v-validate="modelValidate.street">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.city')}}</label>
                  <input type="text" v-model="location.city" name="city" :placeholder="$t('settingCompany.city')" class="form-control" v-validate="modelValidate.city">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.country')}}</label>
                  <select v-model="location.country"
                          name="country"
                          class="select-primary form-control"
                          ref="country"
                          v-validate="modelValidate.country"
                          @change="updateCountry(location)">
                    <option v-for="country in countriesList"
                            class="select-primary"
                            :value="country.alpha2">{{country.name}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.state')}}</label>
                  <template v-if="showStateDrop(location)">
                    <select v-model="location.state_id"
                            class="select-primary form-control">
                      <option v-for="state in getStatesOptions(location)"
                            class="select-primary"
                            :value="state.id">{{state.name}}
                      </option>
                    </select>
                  </template>
                  <template v-else>
                    <input type="text" v-model="location.state" name="state"  class="form-control" v-validate="modelValidate.state">
                  </template>
                </div>
              </div>
              <div class="col-md-12" style="display: none;">
                <div class="form-group">
                  <h6 class="pad-to-10">{{$t('settingCompany.availableDaysHrs')}}</h6>
                  <hr class="sm">
                  <div class="row" v-for="day in location.working_hours">
                    <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12 padd in-inline-160">
                      <p-checkbox
                          :value="day.day"
                          :key="day.day"
                          :label="day.day"
                          v-model="day.open">{{day.day | capitalize}}</p-checkbox>
                    </div>
                    <div class="col-lg-5 col-md-4 col-sm-4 col-xs-12 padd">
                      {{$t('settingCompany.from')}}
                      <el-time-select :disabled="!day.open"
                                      placeholder="Select time"
                                      :value="day.open_from"
                                      :value-format="timeFormat"
                                      v-model="day.open_from"
                                      v-validate="modelValidate.working_hours"
                                      :picker-options="pickerOptions">
                      </el-time-select>
                      {{$t('settingCompany.to')}}
                      <el-time-select :disabled="!day.open"
                                      placeholder="Select time"
                                      :value="day.open_to"
                                      :value-format="timeFormat"
                                      v-model="day.open_to"
                                      v-validate="modelValidate.working_hours"
                                      :picker-options="pickerOptions">
                      </el-time-select>
                    </div>
                <!--     <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 padd">
                       {{$t('settingCompany.preOrder')}}
                      <el-time-select :disabled="!day.open || !location.allow_preorder"
                                      placeholder="Select time"
                                      :value="day.preorder_from"
                                      :value-format="timeFormat"
                                      v-model="day.preorder_from"
                                      v-validate="modelValidate.working_hours"
                                      :picker-options="pickerOptions">
                      </el-time-select>
                    </div> -->
                  </div>
                <!--   <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12 padd in-inline-160">
                    </div>
                    <div class="col-lg-5 col-md-4 col-sm-4">
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 padd">
                      <p-checkbox
                          :value="location.allow_preorder"
                          :key="location.allow_preorder"
                          :label="location.allow_preorder"
                          v-model="location.allow_preorder"
                          @input="checkVal(location)">{{$t('settingCompany.allowPreOrder')}}</p-checkbox>
                    </div>
                  </div> -->
                  <small class="text-danger" v-if="errors.has('working_hours')">
                    {{ getError('working_hours') }}
                  </small>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <h6>{{$t('settingCompany.userTaxes')}}</h6>
                  <hr class="sm">
                  <table class="table mar-bt-0">
                    <thead>
                        <tr>
                          <th>{{$t('settingTaxes.single')}}</th>
                          <th>{{$t('settingTaxes.type')}}</th>
                          <th>{{$t('settingTaxes.amount')}}</th>
                          <th></th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-for="tax_rate in location.taxes">
                        <!-- <input type="hidden" :name="'tax_rate'+tax_rate.id" v-model="tax_rate.id"> -->
                        <td>
                          <select v-model="tax_rate.id"
                                  class="form-control"
                                  v-validate="{required: true}" >
                            <option v-for="tax in taxes"
                                    :value="tax.id"
                                    :disabled="disableTaxOption(location.id, tax.id) && tax.id != tax_rate.id"
                                    >{{tax.name}}</option>
                          </select>
                        <!--   <input type="text"
                                    min="0"
                                    class="form-control"
                                    :name="'name'+tax_rate.id"
                                    v-validate="{required: true}"
                                    v-model="tax_rate.name">  -->
                            <small class="text-danger" v-if="errors.has(tax_rate.hash_id)">
                              {{ getError(tax_rate.hash_id) }}
                            </small>
                          </td>
                          <td>
                            <select :name="'type'+tax_rate.id" v-model="tax_rate.type" class="form-control" v-validate="{required: true}" >
                              <option value="FIXED_INCLUDED">{{$t('taxTypes.FIXED_INCLUDED')}}</option>
                              <option value="FIXED_EXCLUDED">{{$t('taxTypes.FIXED_EXCLUDED')}}</option>
                              <option value="PERCENTAGE_INCLUDED">{{$t('taxTypes.PERCENTAGE_INCLUDED')}}</option>
                              <option value="PERCENTAGE_EXCLUDED">{{$t('taxTypes.PERCENTAGE_EXCLUDED')}}</option>
                            </select>
                          <td>
                            <label class="label-currency">{{tax_rate.type == 'FIXED' ? currency : '%'}}</label>

                            <input type="number" min="0" class="form-control field-currency" :name="'amount'+tax_rate.id" v-model="tax_rate.amount" v-validate="{required: true, min_value:0}" >
                          </td>
                          <td><button class="btn btn-danger btn-icon pull-right" @click.prevent="deleteTax(location.id, tax_rate.id)"><i title="Remove" class="ti-close "></i></button></td>
                      </tr>
                      <tr v-if="location.taxes.length < taxes.length">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    :title="$t('general.add')"
                    class="btn btn-icon btn-info"
                    v-if="location.taxes.length < taxes.length"
                    @click.prevent="addNewTax(location.id)">
                    <i class="ti-plus"></i> {{$t('general.add')}} {{$t('settingTaxes.single')}}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </template>

      <!-- <div class="col-md-12 text-center pad-to-10 pad-bt-10">
        <span v-if="showUpdateWarning" class="help-block warning">{{$t('settingCompany.noTaxMsg')}}</span>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-success btn-wd">{{$t('general.update')}}</button>
      </div> -->
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import 'sweetalert2/dist/sweetalert2.css'
  // import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      [Input.name]: Input,
      PSwitch
    },
    props: {
      countries: {},
      modeldata: {},
      taxesData: {},
      tabRefresh: {}
    },
    watch: {
      countries (value) {
        this.countriesList = value
      },
      modeldata (value) {
        for (var idx in value.locations_details) {
          if (!value.locations_details[idx].working_hours) {
            value.locations_details[idx].working_hours = []
          }
          if (!value.locations_details[idx].allow_preorder) {
            value.locations_details[idx].allow_preorder = false
          }
          for (var iDay in this.days) {
            var day = this.days[iDay]
            var index = this.getObjectByElemKeyValue('day', day, value.locations_details[idx].working_hours)
            if (index === false) {
              value.locations_details[idx].working_hours.push({day: day, open_to: '', open_from: '', open: false})
              // value.locations_details[idx].working_hours.push({day: day, open_to: '', open_from: '', open: false, preorder_from: ''})
            } else if (value.locations_details[idx].working_hours[index].open === undefined) {
              // if (value.locations_details[idx].working_hours[index].open_to !== '' &&
              //     value.locations_details[idx].working_hours[index].open_from !== '') {
              //   value.locations_details[idx].working_hours[index].open = true
              // } else {
              //   value.locations_details[idx].working_hours[index].open = false
              // }
              // console.warn(value.locations_details[idx].working_hours[index].preorder_from)
              // if (value.locations_details[idx].working_hours[index].preorder_from === undefined) {
              //   value.locations_details[idx].working_hours[index].preorder_from = ''
              // }
            }
          }
        }
        this.showDelete = value.locations_details.length > 1
        this.model = value
      },
      taxesData (value) {
        this.taxes = value
      },
      tabRefresh (value) {
        if (value === 'Company Details') {
          this.showUpdateWarning = false
          var data = {
            token: this.$session.get('token')
          }
          var self = this
          var companyID = this.$session.get('selectedCompany')

          this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response) {
            if (response.status === true) {
              self.$emit('updateModelData', response.data[0])
            }
          })
        }
      }
    },
    data () {
      return {
        model: this.value || this.modeldata,
        countriesList: this.value || this.countries, // this.countries
        states: [],
        taxes: this.value || this.taxesData,
        currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
        showDelete: false,
        modelValidate: {
          name: {required: true},
          email: {required: true},
          phone: {required: true},
          street: {required: true},
          city: {required: true},
          state: {required: true},
          country: {required: true},
          working_hours: {required: true}
        },
        timeFormat: 'HH:mm', // this.getCompanyDetail('time_format'),
        dateFormat: 'DD/MM/YYYY', // this.getCompanyDetail('date_format'),
        pickerNames: ['date_from', 'date_to'],
        days: [
          this.$t('days.monday'),
          this.$t('days.tuesday'),
          this.$t('days.wednesday'),
          this.$t('days.thursday'),
          this.$t('days.friday'),
          this.$t('days.saturday'),
          this.$t('days.sunday')
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59',
          format: this.timeFormat
        },
        showUpdateWarning: false,
        languages: this.$session.get('defaultData')['available_languages'],
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 76,
        loading: true
      }
    },
    updated: function () {
    },
    computed: {
    },
    created () {
      this.timeFormat = this.getCompanyDetail('time_format')
      this.dateFormat = this.getCompanyDetail('date_format')
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()
        this.loading = false

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      checkVal (location) {
        console.warn(location.allow_preorder)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate (pageId) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          } else {
            console.warn(this.errors)
          }
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      showStateDrop (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          // location.states = countries[countryIdx].states
          return true
        } else {
          return false
        }
      },
      getStatesOptions (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return countries[countryIdx].states
        } else {
          return []
        }
      },
      updateCountry (location) {
        location.state = null
        location.state_id = null
      },
      disableTaxOption (locId, taxId) {
        let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.model.locations_details[locIdx]['taxes'])

        if (thisTaxIdx !== false) {
          return true
        } else {
          return false
        }
      },
      addLocation () {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes'
        }
        var self = this
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newRow = {
              id: null,
              city: '',
              country: '',
              email: null,
              name: null,
              taxes: [],
              ordering_management: [
                {
                  type: 'pick_up',
                  label: 'Pick-up',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  payment_options: {cash: false, credit_card: false}
                },
                {
                  type: 'meet_half',
                  label: 'Meet me half way',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  payment_options: {cash: false, credit_card: false},
                  locations: []
                },
                {
                  type: 'delivery',
                  label: 'Delivery',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  payment_options: {cash: false, credit_card: false},
                  cost: null,
                  shipping_cost: []
                },
                {
                  type: 'eat_location',
                  label: 'Eat on location',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  payment_options: {cash: false, credit_card: false}
                }
              ],
              phone: null,
              street: null,
              working_hours: []
              // allow_preorder: false
            }
            // newRow = self.newLocation
            newRow.id = response.data[0].id

            newRow.isNew = true

            for (let iDay in self.days) {
              // newRow.working_hours.push({day: self.days[iDay], open_to: '', open_from: '', open: false, preorder_from: ''})
              newRow.working_hours.push({day: self.days[iDay], open_to: '', open_from: '', open: false})
            }

            for (let iOrder in newRow.ordering_management) {
              for (let iDay in self.days) {
                newRow.ordering_management[iOrder].available_days.push({day: self.days[iDay], open_to: '', open_from: '', open: false})
              }
            }

            self.model.locations_details.push(newRow)

            // location-card
            var locationsHtml = self.$el.querySelectorAll('.location-card')
            var lastLoc = locationsHtml[locationsHtml.length - 1]
            self.$nextTick(function () {
              if (locationsHtml.length < 2) {
                self.scrollToPx(lastLoc.clientHeight - 140)
              } else {
                self.scrollToPx(lastLoc.clientHeight)
              }
            })
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      scrollToPx (px) {
        console.warn(px)
        var elem = this.$el
        console.warn(elem.clientHeight)
        elem.scrollTop = elem.clientHeight
        window.scrollTo({
          left: 0,
          top: elem.clientHeight - px,
          behavior: 'smooth'
        })
      },
      deleteLocation (id) {
        var btnCounter = 3
        var self = this
        swal({
          text: self.$t('settingCompany.areYouSureDelete'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            var locIdx = this.getObjectByElemKeyValue('id', id, this.model.locations_details)
            if (locIdx) {
              // delete this.model.locations_details[locIdx]
              this.model.locations_details.splice(locIdx, 1)
            }
            this.saveDetails()
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = 'Yes (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = 'Yes'
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      addNewTax (locId) {
        let newRow = {
          'id': null,
          'type': null,
          'amount': null
        }
        var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        if (locIdx) {
          if (this.model.locations_details[locIdx]['taxes'] === undefined) {
            this.model.locations_details[locIdx].push({'taxes': []})
          }
          this.model.locations_details[locIdx]['taxes'].push(newRow)
          this.showUpdateWarning = true
        }
      },
      deleteTax (locId, taxId) {
        var self = this
        swal({
          text: self.$t('settingCompany.areYouSureTax'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
            let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.model.locations_details[locIdx]['taxes'])
            this.model.locations_details[locIdx]['taxes'].splice(thisTaxIdx, 1)
            this.showUpdateWarning = true
            // swal({'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
          }
        })
        .catch({})
      },
      saveDetails () {
        this.$nextTick(function () { this.loading = true })
        var companyID = this.$session.get('selectedCompany')
        var countries = this.$session.get('defaultData').countries
        var currentLocations = []
        for (var locIdx in this.model.locations_details) {
          var locData = this.copyObject(this.model.locations_details[locIdx])
          console.warn(locData)
          let countryIso = locData.country
          let countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
          let states = []

          if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
            states = countries[countryIdx].states
          }

          if (states.length && locData.state_id) {
            var state = this.getObjectByElemKeyValue('id', locData.state_id, states)
            if (state !== undefined) {
              locData.state = states[state].name
            } else {
              locData.state = ''
            }
          }
          delete locData.states
          currentLocations[locIdx] = locData
        }
        if (this.model.tips_taxes === null) {
          this.model.tips_taxes = []
        }
        var data = {
          'token': this.$session.get('token'),
          'name': this.model.name,
          'language': this.model.language,
          'locations_details': JSON.stringify(currentLocations),
          'tips_taxes': JSON.stringify(this.model.tips_taxes),
          'tips_in_use': this.model.tips_in_use ? 1 : 0
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.$emit('updateModelData', response.data[0])
            self.$session.set('companyName', data.name)
            self.errors.clear()
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('settingCompany.companyUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            self.$emit('companyName', data.name)
            self.showDelete = self.model.locations_details.length > 1
          } else {
            self.$nextTick(function () { self.loading = false })
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/CompanyDetails.vue